"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shopCarOrderApi = _interopRequireWildcard(require("@/api/shopCarOrderApi"));
var _ShopCarOrderDetail = _interopRequireDefault(require("./components/ShopCarOrderDetail.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ShopCarOrderList',
  components: {
    ShopCarOrderDetail: _ShopCarOrderDetail.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        orderNo: '',
        productName: '',
        phone: '',
        plateNo: '',
        parkName: '',
        orderStatus: '',
        orderType: '',
        inStartTime: '',
        inEndTime: '',
        outStartTime: '',
        outEndTime: '',
        orderStartTime: '',
        orderEndTime: ''
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: false,
      inTimeRange: [],
      outTimeRange: [],
      orderDateRange: [],
      orderStatusOptions: [{
        label: '全部',
        value: ''
      }, {
        label: '待支付',
        value: 1
      }, {
        label: '已完成',
        value: 2
      }, {
        label: '已取消',
        value: 3
      }, {
        label: '订单异常',
        value: 4
      }],
      orderTypeOptions: [{
        label: '全部',
        value: ''
      }]
    };
  },
  mounted: function mounted() {
    this.handlerGetListData();
  },
  methods: {
    // 处理入场时间范围变化
    handleInTimeChange: function handleInTimeChange(val) {
      if (val && val.length === 2) {
        this.listPram.inStartTime = val[0];
        this.listPram.inEndTime = val[1];
      } else {
        this.listPram.inStartTime = '';
        this.listPram.inEndTime = '';
      }
    },
    // 处理出场时间范围变化
    handleOutTimeChange: function handleOutTimeChange(val) {
      if (val && val.length === 2) {
        this.listPram.outStartTime = val[0];
        this.listPram.outEndTime = val[1];
      } else {
        this.listPram.outStartTime = '';
        this.listPram.outEndTime = '';
      }
    },
    // 处理下单时间范围变化
    handleOrderDateChange: function handleOrderDateChange(val) {
      if (val && val.length === 2) {
        this.listPram.orderStartTime = val[0];
        this.listPram.orderEndTime = val[1];
      } else {
        this.listPram.orderStartTime = '';
        this.listPram.orderEndTime = '';
      }
    },
    // 搜索
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    // 重置
    handleReset: function handleReset() {
      this.listPram = {
        page: 1,
        limit: this.$constants.page.limit[0],
        orderNo: '',
        productName: '',
        phone: '',
        plateNo: '',
        parkName: '',
        orderStatus: '',
        orderType: '',
        inStartTime: '',
        inEndTime: '',
        outStartTime: '',
        outEndTime: '',
        orderStartTime: '',
        orderEndTime: ''
      };
      this.inTimeRange = [];
      this.outTimeRange = [];
      this.orderDateRange = [];
      this.handlerGetListData();
    },
    // 获取列表数据
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      this.listLoading = true;
      shopCarOrderApi.getShopCarOrderList(this.listPram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        console.error('获取订单列表失败:', err);
        _this.$message.error(err.message || '获取订单列表失败');
        _this.listLoading = false;
      });
    },
    // 分页大小变化
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData();
    },
    // 当前页变化
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    },
    // 打开订单详情
    openOrderDetail: function openOrderDetail(row) {
      if (!row || !row.orderNo) {
        this.$message.warning('订单编号缺失');
        return;
      }
      if (this.$refs.shopCarOrderDetailRef) {
        this.$refs.shopCarOrderDetailRef.open(row.orderNo);
      }
    }
  }
};